import i18nextService from '../services/translations/i18nextService';
import { observable } from 'mobx';

class TranslationsStore {
	@observable currentLocale;

    constructor(){
        i18nextService.init();
    }

    setLanguage(locale){        
        this.currentLocale = locale;
    }

    translate = (key) => {
        let trans = i18nextService.t(key, this.currentLocale);
        return trans;
    }

    translateWithArguments = (stringKey, paramValues) => {
        let translatedString = i18nextService.t(stringKey, this.currentLocale);
        
        if (paramValues != null && Array.isArray(paramValues) && paramValues.length > 0) {
            for (var i = 0; i < paramValues.length; i++) {
                if (translatedString.indexOf("{" + i + "}") > 0) {
                    translatedString = translatedString.replace("{" + i + "}", paramValues[i]);
                }
            }
        }
        return translatedString;
    }
}

export default new TranslationsStore();